import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hall-two',
  templateUrl: './hall-two.component.html',
  styleUrls: ['./hall-two.component.scss']
})
export class HallTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
